.root {
    composes: darkBase from "../../styles/theming.module.css";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(var(--black-base) / 65%);
    backdrop-filter: blur(15px);
    transition: opacity 0.3s;
}

.rootInactive {
    composes: root;
    opacity: 0;
    pointer-events: none;
}

.rootActive {
    composes: root;
    opacity: 1;
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.menu {
    composes: listReset from "../../styles/composable/utility.module.css";
    grid-column: 1 / -1;
    color: var(--color-text-primary);
}

.level1 {
    --margin-top: calc(var(--spacer-24) + var(--main-nav-height));

    composes: menu;
    height: calc(100vh - var(--margin-top));
    margin-top: var(--margin-top);
    padding-bottom: var(--spacer-48);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.menuLevel2 {
    composes: menu;
    padding-left: var(--spacer-32);
    border-left: 1px solid var(--color-text-primary);
    margin-block: var(--spacer-12);
}

.link {
    display: inline-block;
    align-items: center;
    padding-block: var(--spacer-16);
    font: var(--font-h-32);

    svg {
        fill: currentColor;
        width: var(--spacer-32);
        height: var(--spacer-32);
        margin-left: var(--spacer-16);
        vertical-align: -0.2em;
    }
}

.linkLevel1 {
    composes: link;
}

.linkLevel2 {
    composes: link;
}
